import type { Environment } from '#app/shared/contexts/AppContext'
import posthog from 'posthog-js'
import type { AuthContextResult } from '../contexts/AuthContext'
import type { EventData } from './eventPublishing'

export const initializePostHog = (environment: Environment) => {
  const posthogApiKey = environment.POSTHOG_API_KEY

  if (!posthogApiKey) {
    console.error('PostHog API key is not set')
  }

  posthog.init(posthogApiKey || '', {
    api_host: 'https://us.i.posthog.com',
    capture_exceptions: true,
    enable_recording_console_log: true,
    session_recording: {
      maskAllInputs: false
    }
  })
}

/**
 * Set the user with PostHog.
 * @param authContext
 */
export const setPostHogUser = (authContext: AuthContextResult) => {
  const { externalContext, userKey } = authContext
  if (!externalContext) {
    return
  }
  const { userEmail, userFullName } = authContext

  posthog.identify(userKey, {
    name: userFullName || '',
    ...externalContext
  })
  console.debug('posthog identify', { userKey, userEmail, userFullName })
}

/*
 * @param eventName The event name must be in PascalCase
 * @param eventProperties A dictionary with key-value pairs, The "keys" must be in camelCase.
 */
export const publishPostHogEvent = (event: string, properties: EventData) => {
  try {
    posthog.capture(event, properties)
  } catch (error) {
    console.error('Error publishing PostHog event', error)
  }
}
